module.exports = __webpack_public_path__ + "img/Yaoqi_Zhou-1.873d67cc.png";